import { phappsRequest } from './apiService';
import { buildDispenseReportPath } from '@/config/apiConstants';

const p = (path, params) => {
  const base = buildDispenseReportPath(path);
  if (!params) return base;
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  ).toString();
  return qs ? `${base}?${qs}` : base;
};

export const getProviders    = ()              => phappsRequest(p('Providers'), 'GET');
export const saveContact     = (key, body)     => phappsRequest(p(`Providers/${key}`), 'PUT', body);
export const saveInvoiceEmail = (email)        => phappsRequest(p('InvoiceEmail'), 'PUT', { email });
export const getReport       = (params)        => phappsRequest(p('Report', params), 'GET');
export const sendReport      = (body)          => phappsRequest(p('Send'), 'POST', body);
